import type { Entitlement } from '../../types'

interface ActivationStatsSummaryProps {
  entitlements: Entitlement[]
}

interface StatTileProps {
  label: string
  value: number
  valueClass?: string
}

function StatTile({ label, value, valueClass }: StatTileProps): React.ReactElement {
  const finalValueClass = valueClass ?? 'text-stone-900 dark:text-stone-100'
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-4 dark:border-stone-700 dark:bg-stone-800">
      <p className="text-sm text-stone-500 dark:text-stone-400">{label}</p>
      <p className={`text-2xl font-semibold ${finalValueClass}`}>{value}</p>
    </div>
  )
}

export function ActivationStatsSummary({
  entitlements,
}: ActivationStatsSummaryProps): React.ReactElement {
  const activeCount = entitlements.filter((entry) => entry.status === 'active').length
  const pendingCount = entitlements.filter((entry) => entry.status === 'pending').length
  const paymentGateCount = entitlements.filter((entry) => entry.paymentGatePassed).length
  const bothGatesCount = entitlements.filter((entry) => entry.gatesPassed).length
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
      <StatTile label="Total Entitlements" value={entitlements.length} />
      <StatTile
        label="Active"
        value={activeCount}
        valueClass="text-green-600 dark:text-green-400"
      />
      <StatTile
        label="Pending"
        value={pendingCount}
        valueClass="text-amber-600 dark:text-amber-400"
      />
      <StatTile
        label="Payment Gate"
        value={paymentGateCount}
        valueClass="text-[#5c6e94] dark:text-[#8a9bba]"
      />
      <StatTile
        label="Both Gates"
        value={bothGatesCount}
        valueClass="text-[#5c6e94] dark:text-[#8a9bba]"
      />
    </div>
  )
}
